import { Injectable } from '@angular/core';

import { HttpGeneralService } from '../../shared/shared';
import { CONFIG } from '../../shared/config';

let dictionariesUrl = CONFIG.baseUrls.dictionaries;
export interface Dictionary {
    serial: number;
    nameAr: string;
    name2Ar: string;
    nameEn: string;
    gender: number;
}


@Injectable({
  providedIn: 'root'
})
export class DictionaryService {
    constructor(
        private httpGeneralService: HttpGeneralService) { }

    getDictionaryTranslate(name: string) {
        return this.httpGeneralService.getWith(`${dictionariesUrl}/${name}`);
    }

    convertchar(letter) {
        if (letter == "ا") { return "a" }
        else if (letter == "أ") { return "a" }
        else if (letter == "آ") { return "a" }
        else if (letter == "إ") { return "e" }
        else if (letter == "ب") { return "b" }
        else if (letter == "ت") { return "t" }
        else if (letter == "ث") { return "th" }
        else if (letter == "ج") { return "j" }
        else if (letter == "ح") { return "h" }
        else if (letter == "خ") { return "kh" }
        else if (letter == "د") { return "d" }
        else if (letter == "ذ") { return "d" }
        else if (letter == "ر") { return "r" }
        else if (letter == "ز") { return "z" }
        else if (letter == "س") { return "s" }
        else if (letter == "ش") { return "sh" }
        else if (letter == "ص") { return "s" }
        else if (letter == "ض") { return "d" }
        else if (letter == "ط") { return "t" }
        else if (letter == "ظ") { return "z" }
        else if (letter == "ع") { return "a" }
        else if (letter == "غ") { return "gh" }
        else if (letter == "ف") { return "f" }
        else if (letter == "ق") { return "q" }
        else if (letter == "ك") { return "k" }
        else if (letter == "ل") { return "l" }
        else if (letter == "م") { return "m" }
        else if (letter == "ن") { return "n" }
        else if (letter == "ه") { return "h" }
        else if (letter == "و") { return "w" }
        else if (letter == "ي") { return "y" }
        else if (letter == "ى") { return "y" }
        else if (letter == "ئ") { return "'e" }
        else if (letter == "ء") { return "a" }
        else if (letter == "ؤ") { return "ao" }
        else if (letter == "لا") { return "la" }
        else if (letter == "ة") { return "h" }
        else if (letter == "؟") { return "?" }
        else if (letter == "!") { return "!" }
        else if (letter == "ـ") { return "" }
        else if (letter == "،") { return "," }
        else if (letter == "َ‎") { return "a" }
        else if (letter == "ُ") { return "u" }
        else if (letter == "ِ‎") { return "e" }
        else if (letter == "ٌ") { return "un" }
        else if (letter == "ً") { return "an" }
        else if (letter == "ٍ") { return "en" }
        else if (letter == "ّ") { return "" }
        else if (letter == "\n") { return "\n" }
        else return letter
    }

    // convertcharEnToAr(letter) {
    //     if (letter == "a") { return "ا" }
    //     else if (letter == "a") { return "أ" }
    //     else if (letter == "a") { return "آ" }
    //     else if (letter == "e") { return "إ" }
    //     else if (letter == "b") { return "ب" }
    //     else if (letter == "t") { return "ت" }
    //     else if (letter == "th") { return "ث" }
    //     else if (letter == "j") { return "ج" }
    //     else if (letter == "h") { return "ح" }
    //     else if (letter == "kh") { return "خ" }
    //     else if (letter == "d") { return "د" }
    //     else if (letter == "z") { return "ذ" }
    //     else if (letter == "r") { return "ر" }
    //     else if (letter == "z") { return "ز" }
    //     else if (letter == "s") { return "س" }
    //     else if (letter == "sh") { return "ش" }
    //     else if (letter == "s") { return "ص" }
    //     else if (letter == "d") { return "ض" }
    //     else if (letter == "t") { return "ط" }
    //     else if (letter == "z") { return "ظ" }
    //     else if (letter == "a") { return "ع" }
    //     else if (letter == "gh") { return "غ" }
    //     else if (letter == "f") { return "ف" }
    //     else if (letter == "q") { return "ق" }
    //     else if (letter == "k") { return "ك" }
    //     else if (letter == "l") { return "ل" }
    //     else if (letter == "m") { return "م" }
    //     else if (letter == "n") { return "ن" }
    //     else if (letter == "h") { return "ه" }
    //     else if (letter == "w") { return "و" }
    //     else if (letter == "y") { return "ي" }
    //     else if (letter == "'e") { return "ئ" }
    //     else if (letter == "a") { return "ء" }
    //     else if (letter == "ao") { return "ؤ" }
    //     else if (letter == "la") { return "لا" }
    //     else if (letter == "h") { return "ة" }
    //     else if (letter == "?") { return "؟" }
    //     else if (letter == "!") { return "!" }
    //     else if (letter == "") { return "ـ" }
    //     else if (letter == ",") { return "،" }
    //     else if (letter == "a") { return "َ‎" }
    //     else if (letter == "u") { return "ُ" }
    //     else if (letter == "e") { return "ِ‎" }
    //     else if (letter == "un") { return "ٌ" }
    //     else if (letter == "an") { return "ً" }
    //     else if (letter == "en") { return "ٍ" }
    //     else if (letter == "") { return "ّ" }
    //     else if (letter == "\n") { return "\n" }
    //     else return letter
    // }

    translateToEn(nameAr: string): string {
        if (nameAr == null || nameAr == undefined)
            nameAr = ''
        let nameEn = "";
        for (let i = 0; i < nameAr.length; i++)
            (
                nameEn += this.convertchar(nameAr.charAt(i))
            )

        let str1 = nameEn;
        let str2 = str1.charAt(0).toUpperCase() + str1.slice(1);
        return str2;
    }

    // translateToAr(nameEn: string): string {
    //     if (nameEn == null || nameEn == undefined)
    //         nameEn = ''
    //     let nameAr = "";
    //     for (let i = 0; i < nameEn.length; i++)
    //         (
    //             nameAr += this.convertcharEnToAr(nameEn.charAt(i))
    //         )
    //     return nameAr
    // }
}
